<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    stream_apps
                </mat-icon>
                <span>
                    Text Message: {{ itemEnvelope?.Document?.Item?.Name }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Message: {{ itemEnvelope?.Document?.Item?.TextMessageId }} - {{ itemEnvelope?.Document?.Item?.Name }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="flex-container-basic flex-direction-horizontal">
                <mat-form-field appearance="outline" class="responsive-width">
                    <mat-label>From Phone Number</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="FromNumber" placeholder="FromNumber" [(ngModel)]="$any(itemEnvelope).Document.Item.FromNumber" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="responsive-width">
                    <mat-label>To Phone Number</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="ToNumber" placeholder="ToNumber" [(ngModel)]="$any(itemEnvelope).Document.Item.ToNumber" />
                </mat-form-field>
            </div>
            <div class="flex-container-basic flex-direction-horizontal">
                <mat-form-field appearance="outline" class="responsive-width">
                    <mat-label>Send After (UTC)</mat-label>
                    <input matInput type="datetime-local"
                           name="SendAfterUTC"
                           [(ngModel)]="itemEnvelope!.Document!.Item!.SendAfterUTC" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="responsive-width">
                    <mat-label>Gateway Provider</mat-label>
                    <mat-select [(ngModel)]="itemEnvelope!.Document!.Item!.GatewayProviderProviderTypeId">
                        <mat-option *ngFor="let gppt of gatewayProviderProviderTypes"
                                    [value]="gppt.GatewayProviderProviderTypeId">
                            {{ gppt.GatewayProviderName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <mat-tab-group>
                <br />
                <mat-tab label="TextMessage">
                    <br />
                    <mat-form-field style="width:100%;height: 40%;" appearance="outline">
                        <mat-label>Body</mat-label>
                        <textarea matInput name="messageBody" rows="20" placeholder="" [(ngModel)]="itemEnvelope!.Document!.Item!.Body!" style="font-family: 'Source Code Pro', monospace;"></textarea>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
